import api from './api';
import {
  AmortizationOperation,
  AmortizationOperationRequest,
  CapitalAmortization,
  CapitalAmortizationUpdate,
  EstadoAmortizacion,
} from '../types/CapitalAmortization';

// Amortizaciones anticipadas de capital (no confundir con amortizationService: calendario de pagos)
export const capitalAmortizationService = {
  getOperaciones: () => api.get<AmortizationOperation[]>('/amortizaciones/operaciones'),
  getOperacion: (id: string) => api.get<AmortizationOperation>(`/amortizaciones/operaciones/${id}`),
  createOperacion: (data: AmortizationOperationRequest) =>
    api.post<AmortizationOperation>('/amortizaciones/operaciones', data),
  updateOperacion: (id: string, data: AmortizationOperationRequest) =>
    api.put<AmortizationOperation>(`/amortizaciones/operaciones/${id}`, data),
  deleteOperacion: (id: string) => api.delete(`/amortizaciones/operaciones/${id}`),
  generarPropuestas: (id: string) =>
    api.post<AmortizationOperation>(`/amortizaciones/operaciones/${id}/propuestas`),
  // Remesa SEPA (XML) del pago de las amortizaciones ejecutadas
  remesa: (id: string) =>
    api.get<Blob>(`/amortizaciones/operaciones/${id}/remesa`, { responseType: 'blob' }),

  getByInvestor: (investorId: string) =>
    api.get<CapitalAmortization[]>('/amortizaciones', { params: { investorId } }),
  getBySheet: (sheetId: string) =>
    api.get<CapitalAmortization[]>('/amortizaciones', { params: { sheetId } }),
  update: (id: string, data: CapitalAmortizationUpdate) =>
    api.put<CapitalAmortization>(`/amortizaciones/${id}`, data),
  cambiarEstado: (id: string, estado: EstadoAmortizacion) =>
    api.post<CapitalAmortization>(`/amortizaciones/${id}/estado`, { estado }),
  ejecutar: (id: string) => api.post<CapitalAmortization>(`/amortizaciones/${id}/ejecutar`),
  anular: (id: string) => api.post<CapitalAmortization>(`/amortizaciones/${id}/anular`),
};
